 // export const domain = "http://ncd.ddc.moph.go.th/satsystem/public/api";
 //---------- Production -----------
 // export const domain = "https://dip.ddc.moph.go.th/satsystem/public/api";
 // export const domain_dashboard = "http://dip.ddc.moph.go.th/drowningdashboard/public/";

 //---------- New Production -----------
 export const domain = "https://drowningreport.ddc.moph.go.th/satsystem/public/index.php/api";
 export const domain_dashboard = "https://drowningreport.ddc.moph.go.th/drowningdashboard/public/";

 //-----------Local-----------
// export const domain = "http://127.0.0.1:8000/api";
// export const domain = "https://satsystem.famikinnovation.com/api";

 //---------- Test -----------
 // export const domain = "https://dip.ddc.moph.go.th/test/satsystem/public/api";
 // export const domain_dashboard = "http://dip.ddc.moph.go.th/test/drowningdashboard/public/";

 //---------- KISRA DEV -----------
 // export const domain = "https://sat-drowning.ksta.co/api";
 // export const domain_dashboard = "https://sat-dashboard.ksta.co";
